import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../services/central-api/dispatch';
import { translate } from '../../services/translate';
import { useAuth } from '../../context/Auth';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';


type Props = {
    zIndex?: number;
    disabled?: boolean;
    label?: string;
    actingBodyId: number;
} & ({
    form?: undefined;
    fieldName?: undefined;
    customValidations?: undefined;
    pattern?: undefined;
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function OccurrenceTypesDropdown({ value, setValue, zIndex, disabled, label, actingBodyId, form, fieldName }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);
    const { user: authenticatedUser } = useAuth();

    async function getOccurrenceTypes() {
        try {
            const actingBody = getActingBodyId();
            if (actingBody === 0) {
                setItems([]);
                return;
            }
            const response = await dispatchService.getDropDownOccurrenceTypes(actingBody);
            setItems(response.map(occurrenceType => ({
                label: occurrenceType.name, value: occurrenceType.id!
            })));
        } catch (err) {
            console.error(err);
        }
    }

    function getActingBodyId() {
        if (!authenticatedUser || !authenticatedUser.actingBodyUnit.actingBodyId) {
            return 0;
        }

        if (authenticatedUser.isAdmin || authenticatedUser.permissions.dispatch_manage_all_acting_bodies_occurrences) {
            return actingBodyId;
        } else {
            return authenticatedUser.actingBodyUnit.actingBodyId;
        }
    }

    useEffect(() => {
        getOccurrenceTypes();
    }, [actingBodyId]);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={label ?? translate('occurrenceType')}
            items={items}
            multiple={true}
            mode='BADGE'
            fieldName={fieldName}
            form={form}
            zIndex={zIndex}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={label ?? translate('occurrenceType')}
                items={items}
                multiple={true}
                mode='BADGE'
                setValue={setValue}
                value={value}
                zIndex={zIndex}
                disabled={disabled}
            />
        );
    }
}

export default OccurrenceTypesDropdown;
